export type TagType = {
    icon: string,
    tagName: string,
}

export type StoryType = {
    id: string,
    title: string,
    link: string,
    pairing: string,
    pairingId: string,
    description: string,
    completedStatus: string,
    length: string,
    chapters: number,
    tags: TagType[]
};

export let stories: StoryType[];
stories = [
    // -- Incomplete --
    // House Husband
    {
        id: 'House-Husband',
        title: 'House Husband',
        link: 'https://archiveofourown.org/chapters/147490633',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'Hinata wants a husband so she can stop hearing being pestered about it. Itachi wants to retire from the corporate world that is slowly killing him. It’s the perfect match.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Contract Marriage'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Please Marry My Son
    {
        id: 'Please-Marry-My-Son',
        title: 'Please Marry My Son',
        link: 'https://archiveofourown.org/works/78778206',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Tensions between the Hyuga and Uchiha have been high since Itachi came to the Hyuga for help from a possible massacre of the whole clan. The power struggle is something that can be felt throughout the entire village, and it has people worried. The possibility of a marriage contract has been brought up again. Will it actually stick this time?',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Arranged Marriage'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Cannon AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Stitches and Wheat
    {
        id: 'Stitches-and-Wheat',
        title: 'Stitches and Wheat',
        link: 'https://archiveofourown.org/works/83049576',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'He was sure his father had banned magic for a reason, but he wasn\'t making the decisions right now. Sasuke didn\'t have a choice but to solve a magic problem with a magic solution. But was he ready for the consequences? Magic always had its price.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Magic AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Once Again
    {
        id: 'Once-Again',
        title: 'Once Again',
        link: 'https://archiveofourown.org/works/81311421',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Hinata wasn’t sure how she woke up ten years into her own past, before she married the wrong man, before she got caught up in the mess that had her on the run, before she did what ultimately got her killed. She wasn’t sure how she got here, but she had a second chance, and she wasn’t going to waste it.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Time Travel AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Teething
    {
        id: 'Teething',
        title: 'Teething',
        link: 'https://archiveofourown.org/works/88043796',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'New single father Kisame knows that the world is going to be hard for his son just like it was for him, but his neighbor doesn’t seem to mind the baby with a mouth full of shark teeth.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Single Dad AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Photos of You
    {
        id: 'Photos-of-You',
        title: 'Photos of You',
        link: 'https://archiveofourown.org/works/84665846',
        pairing: 'Deidara x Hinata',
        pairingId: 'deihina',
        description: 'Deidara didn’t usually shoot for weddings, but he had never shot for one where the bride didn’t even look like she wanted to be there.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Run Away Bride AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    // Orderly Insubordination
    {
        id: 'Orderly-Insubordination',
        title: 'Orderly Insubordination',
        link: 'https://archiveofourown.org/works/85508736',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'Kakashi is at his wits end with Hidan, a student who already had to repeat the year because he didn\'t do enough of his work to graduate. He needs someone to keep him on track, why not the student who has a fear of failure and in ability to say no?',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'High School AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    // Shadow of the Priestess
    {
        id: 'Shadow-of-the-Priestess',
        title: 'Shadow of the Priestess',
        link: 'https://archiveofourown.org/works/86766071',
        pairing: 'Shikamaru x Hinata',
        pairingId: 'shikahina',
        description: 'A priestess isn’t meant to let demons into the shrine, but maybe exceptions can be made for those who ask nicely.',
        completedStatus: 'Incomplete',
        length: 'multiChapter',
        chapters: 0,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'High School AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // -- Completed --
    // Selfish
    {
        id: 'Selfish',
        title: 'Selfish',
        link: 'https://archiveofourown.org/works/70871191',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'After being let down by everyone in the system that was meant to protect her, she is left wondering why bad people are never punished. She is driven to ask for God to send her a demon to level the playing field. A god responds.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 67,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Revenge'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Dreams
    {
        id: 'Lavender-Dreams',
        title: 'Lavender Dreams',
        link: 'https://archiveofourown.org/works/70871191',
        pairing: 'Shikamaru x Hinata',
        pairingId: 'shikahina',
        description: 'Was watching the girl you love be disappointed as she constantly fails for another man attention worse than actively helping her try to get that man’s attention? Only one way to find out.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 40,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'High School AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // 100 Blind Dates
    {
        id: '100-Blind-Dates',
        title: '100 Blind Dates',
        link: 'https://archiveofourown.org/works/75441711',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke’s mother sends him on 100 blind dates. He is determined for all of them to fail.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 12,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Coffee Shop AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Deviating from the Plot
    {
        id: 'Deviating-from-the-Plot',
        title: 'Deviating from the Plot',
        link: 'https://archiveofourown.org/works/75441711',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'All Hinata wanted to do was get an autograph from the author of her sister’s favorite romance comic writer, but now she found herself as part of the story.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 21,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Transmigration'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Windowsills
    {
        id: 'Windowsills',
        title: 'Windowsills',
        link: 'https://archiveofourown.org/works/69278286',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Growing up neighbors, Hinata and Sasuke have known each other for a very long time, but there was always seemed to be in the way of them getting close, Sasuke\'s mother\'s death, Sasuke going away to school, Hinata going away to university. After all the road blocks are out of the way, will Sasuke start to see Hinata a little differently?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 36,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Neighbor AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Collateral
    {
        id: 'Collateral',
        title: 'Collateral',
        link: 'https://archiveofourown.org/works/70176111',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'Hiashi has fallen into debt to Kakuzu. When Kakuzu comes to collect and he finds his young daughter unintended and he thinks surely he\'s not going to leave his child behind to avoid him… right?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 25,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Dad Kakuzu'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // The Best Revenge
    {
        id: 'The-Best-Revenge',
        title: 'The Best Revenge',
        link: 'https://archiveofourown.org/works/53062477',
        pairing: 'Shikamaru x Hinata',
        pairingId: 'shikahina',
        description: 'Hinata puts her foot down right before she is meant to walk down the aisle. Now what? "The best revenge is for me to do something that makes me happy. That’s the last thing any of them would want.”',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 71,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Marriage of Convenience'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // A Kiss Between Strangers
    {
        id: 'A-Kiss-Between-Strangers',
        title: 'A Kiss Between Strangers',
        link: 'https://archiveofourown.org/works/54401971',
        pairing: 'Gaara x Hinata',
        pairingId: 'gaahina',
        description: 'Neither thought the summer kiss would follow them back to their new university lives. Can Gaara and Hinata get past their odd first interaction as they keep being pushed together?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 76,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    //Love After Death
    {
        id: 'Love-After-Death',
        title: 'Love After Death',
        link: 'https://archiveofourown.org/works/68511316',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata and Sasuke are dead. They don’t know how or why. All they know is not they are dead and wandering around a school that it seems like they attended while they were alive.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 8,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Ghost AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    //In Good Spirits
    {
        id: 'In-Good-Spirits',
        title: 'In Good Spirits',
        link: 'https://archiveofourown.org/works/64307209',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'After Hinata prays to the mountain spirit, the mountain spirit takes an interest.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 36,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Mountain Spirit AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    //Bunny Fluff and Spiked Stuff
    {
        id: 'Bunny-Fluff-and-Spiked-Stuff',
        title: 'Bunny Fluff and Spiked Stuff',
        link: 'https://archiveofourown.org/works/66823534',
        pairing: 'Deidara x Hinata',
        pairingId: 'deihina',
        description: 'The proper prefect student and that guy who is one piercing away from expulsion.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 6,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'High School AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    //Better Late
    {
        id: 'Better-Late',
        title: 'Better Late',
        link: 'https://archiveofourown.org/works/56328979',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'They were so in love once. How did it turn out like this? Looking across a crowded ballroom with the wounds on their hearts still feeling as fresh as the day they were made.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 100,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Emotional Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    // The Yakuza and Miss Bunny
    {
        id: 'The-Yakuza-and-Miss-Bunny',
        title: 'The Yakuza and Miss Bunny',
        link: 'https://archiveofourown.org/works/58822234',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Kisame, an Akatsuki Yakuza, is hired for intimidation tactics and is charmed by the kind heart of Hinata, the school teacher with a secret past.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 61,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Yakuza AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Lights
    {
        id: 'Lavender-Lights',
        title: 'Lavender Lights',
        link: 'https://archiveofourown.org/works/61800070',
        pairing: 'Deidara x Hinata',
        pairingId: 'deihina',
        description: 'Her image displayed confidence she didn’t have, sexuality she wasn’t comfortable with, and music she didn’t write. The unapologetic girl power persona was popular. It wasn’t who Hinata was, but it was who she was directed to be.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 72,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Idol AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },


    // Riding Hearts
    {
        id: 'Riding-Hearts',
        title: 'Riding Hearts',
        link: 'https://archiveofourown.org/works/53919058',
        pairing: '??? x Hinata',
        pairingId: 'other',
        description: 'With no memory and nowhere to go, Hinata is taken in by the Akatsuki motorcycle gang. Will her unknown past come back to haunt her? Who will catch her heart? Rated M for Language. This story will have no couple tag because the fun of this story will be watching all the relationships grow and finding out who she ends up with.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 43,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Memory Loss'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Biker AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Soft Harem'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Red Memories
    {
        id: 'Red-Memories',
        title: 'Red Memories',
        link: 'https://archiveofourown.org/works/50466946',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke wakes up to a life he never expected. Hinata flattened her fiddling hands in her lap. “I’m waiting.” Sasuke huffed. “Waiting for what?” “You to say something you will regret later.” Hinata smiled.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 37,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Memory Loss'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Why Is It Always You?
    {
        id: 'Why-Is-It-Always-You',
        title: 'Why Is It Always You?',
        link: 'https://archiveofourown.org/works/51404452',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata hates living in Sasuke’s shadow. Sasuke can’t stand people thinking Hinata is innocent and well-meaning. They would like nothing more than to stop seeing each other, but the universe seems to have other ideas.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 28,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Enimies to Lovers'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Highschool AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Guarding Affections
    {
        id: 'Guarding-Affections',
        title: 'Guarding Affections',
        link: 'https://archiveofourown.org/works/50151556',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'After an attempted kidnapping Kisame is hired to protect Hinata.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 30,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Body Guard AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Office AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Letters
    {
        id: 'Lavender-Letters',
        title: 'Lavender Letters',
        link: 'https://archiveofourown.org/works/49167538',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'Hinata signs up for a prison pen pal program and is assigned to Hidan, a serial killer known for his brutal murders. Hinata becomes friends with him despite his crass nature. And, oh yeah, they kill her father.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 22,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'No Relationship Abuse'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Prison Pen Pals'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Serial Killer'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Clouds
    {
        id: 'Lavender-Clouds',
        title: 'Lavender Clouds',
        link: 'https://archiveofourown.org/works/46538125',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata runs away from home into the arms of the Akatsuki. Bonds with Itachi. Saves his brother. Learns to reverse Gentle Fist. Finds something better than family? A found family adventure story.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 88,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slow Burn'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Adventure'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Family'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Sand
    {
        id: 'Lavender-Sand',
        title: 'Lavender Sand',
        link: 'https://archiveofourown.org/works/46451251',
        pairing: 'Gaara x Hinata',
        pairingId: 'gaahina',
        description: 'Hinata accepted she would have a political marriage, but Gaara was not what she was expecting. Gaara wasn’t even looking to marry but when presented the opportunity and with Naruto’s approval, maybe it will all work out.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 85,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slow Burn'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Twist on Arranged Marriage'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Friends to Lovers'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Mutual Pining'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Healthy Relationships'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Memories
    {
        id: 'Lavender-Memories',
        title: 'Lavender Memories',
        link: 'https://archiveofourown.org/works/46449580',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'After an accident, Hinata wakes up to find herself several years older and happily married to the last person she expected. "I don’t want to go. I want to know who I married." Sasuke needs to make sure his wife knows why he loves her because she doesn’t remember loving him.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 44,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Memory Loss'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lavender Umbrellas
    {
        id: 'Lavender-Umbrellas',
        title: 'Lavender Umbrellas',
        link: 'https://archiveofourown.org/works/46750711',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Hinata moves to her cousin’s school and makes friends with a misfit study group, namely Kisame. Heartfelt relationship between a shy small girl and a big tough guy.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 37,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Highschool AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Testing Success
    {
        id: 'Testing-Success',
        title: 'Testing Success',
        link: 'https://archiveofourown.org/works/46472983',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata accidentally applies for the director’s assistant position at Uchiha Industries. Though surprised when she gets the job it seems like the director has it out for her. His sons seem to be on her side though.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 62,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slow Burn'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Family'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Office AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Death Wishes
    {
        id: 'Death-Wishes',
        title: 'Death Wishes',
        link: 'https://archiveofourown.org/works/46750087',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'Hinata finds herself the center of a mysterious being’s attention, but what is she hiding that makes it so comforting to be not alone?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 27,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Supernatural AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // What He Left Behind
    {
        id: 'What-He-Left-Behind',
        title: 'What He Left Behind',
        link: 'https://archiveofourown.org/works/46809457',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'When Sasuke is confronted with an abandoned pregnant Hinata, he does the only thing he can think to do, he takes her in. Strangers to friends. Friends to lovers. “So you married her, knocked her up, and decided this isn’t what you wanted?” Sasuke asked in disbelief. “You’re an asshole.”',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 18,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Family'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // I Will Love You
    {
        id: 'I-Will-Love-You',
        title: 'I Will Love You',
        link: 'https://archiveofourown.org/works/48255163',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata and Sasuke make a desperate deal. Can they intentionally fall in love?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 23,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Marriage of Convenience'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Friends to Lovers'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Wheels
    {
        id: 'Wheels',
        title: 'Wheels',
        link: 'https://archiveofourown.org/works/46451539',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'After an accident, Hinata is bound to a wheelchair. She and Sasuke find common ground in their disabilities. Friends to lovers. Light-hearted fluff.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 24,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slice of Life'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Friends to Lovers'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Watch With Me
    {
        id: 'Watch-With-Me',
        title: 'Watch With Me',
        link: 'https://archiveofourown.org/works/51877447',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata and Sasuke bond over bad movies.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 4,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slice of Life'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Friends to Lovers'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Beauty and the Sand Beast
    {
        id: 'Beauty-and-the-Sand-Beast',
        title: 'Beauty and the Sand Beast',
        link: 'https://archiveofourown.org/works/49005439',
        pairing: 'Gaara x Hinata',
        pairingId: 'gaahina',
        description: 'Gaara was deemed too dangerous to keep in Suna at a young age, and since has been living alone in the furthest corner of the desert. Until Hinata is traded to keep him company.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 17,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Slow Burn'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Because It's You
    {
        id: 'Because-Its-You',
        title: 'Because It’s You',
        link: 'https://archiveofourown.org/works/53383555',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'All but given up because of his illness, Itachi finds Hinata as his doctor in a trial for a new treatment for his condition. Hinata promises him a date if he completes the trial to encourage him to keep fighting.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 6,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern Au'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Office Mishap
    {
        id: 'Office-Mishap',
        title: 'Office Mishap',
        link: 'https://archiveofourown.org/works/53719366',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'Hinata regrets being the only person who reads her emails.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 2,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Lighthouse
    {
        id: 'Lighthouse',
        title: 'Lighthouse',
        link: 'https://archiveofourown.org/works/55603546',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Fish-men exist so why not mermaids?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 13,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Mermaid AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // One Wild Night
    {
        id: 'One-Wild-Night',
        title: 'One Wild Night',
        link: 'https://archiveofourown.org/works/61676245',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'Hinata didn’t know why the stranger bailed her out, but he only asked for one thing.',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 6,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Angst and Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Hard Feelings
    {
        id: 'Hard-Feelings',
        title: 'Hard Feelings',
        link: 'https://archiveofourown.org/works/60320098',
        pairing: 'Sasori x Hinata',
        pairingId: 'sasohina',
        description: 'Was it love surging through his circuit boards? Was that what he was created for?',
        completedStatus: 'Complete',
        length: 'multiChapter',
        chapters: 10,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Robot!Sasori'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },


    // -- One-Shots --
    // A Kiss for data Purposes
    {
        id: 'A-Kiss-for-data-Purposes',
        title: 'A Kiss for data Purposes ',
        link: 'https://archiveofourown.org/works/54085048',
        pairing: 'Sasori x Hinata',
        pairingId: 'sasohina',
        description: 'Is it possible for an android to love?',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Ladybug
    {
        id: 'Ladybug',
        title: 'Ladybug',
        link: 'https://archiveofourown.org/works/54558559',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'Itachi is trying to put his life back together. Hinata is too. Maybe they can help each other.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Heart on the Mat
    {
        id: 'Heart-on-the-Mat',
        title: 'Heart on the Mat',
        link: 'https://archiveofourown.org/works/55056835',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Kisame falls in love on a gym mat.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Bread and Tea
    {
        id: 'Bread-and-Tea',
        title: 'Bread and Tea',
        link: 'https://archiveofourown.org/works/49568635',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata comes across a bakery to heal her heart with bread, and is surprised to find who runs it. Maybe it’s not just the bread healing her heart.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Hurt/Comfort'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff & Angst'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Bakery AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Canon Universe'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Run A Way With Me
    {
        id: 'Run-A-Way-With-Me',
        title: 'Run A Way With Me',
        link: 'https://archiveofourown.org/works/49568635',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata wasn’t even meant to be here, but the stranger in the mask knew in her heart she wanted out. One dance was all it took.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // The Witch and The Scarecrow
    {
        id: 'The-Witch-and-The-Scarecrow',
        title: 'The Witch and The Scarecrow',
        link: 'https://archiveofourown.org/works/51056170',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'A soft story about the witch on the hill and the scarecrow that appeared one day.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Witch AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Wedding Blues
    {
        id: 'Wedding-Blues',
        title: 'Wedding Blues',
        link: 'https://archiveofourown.org/works/51569236',
        pairing: 'Lee x Hinata',
        pairingId: 'leehina',
        description: 'Lee and Hinata have a connection at a wedding.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Painting
    {
        id: 'Painting',
        title: 'Painting',
        link: 'https://archiveofourown.org/works/54880801',
        pairing: 'Ino x Hinata',
        pairingId: 'inohina',
        description: 'Hinata and Ino paint a room together.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },

    // 2024 SasuHina Month

    {
        id: 'Festival-Confessions',
        title: 'Festival Confessions',
        link: 'https://archiveofourown.org/works/56407369',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke wonders if a festival is a good place to confess his feelings.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Charms',
        title: 'Charms',
        link: 'https://archiveofourown.org/works/56429932',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke accidentally breaks Hinata’s key chain.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Gullible',
        title: 'Gullible',
        link: 'https://archiveofourown.org/works/56497396',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'How did Itachi know that his little brother was going to take what he said so seriously?',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Skipped',
        title: 'Skipped',
        link: 'https://archiveofourown.org/works/56521891',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata always seems to skip Sasuke when giving out her kindness.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Shelter',
        title: 'Shelter',
        link: 'https://archiveofourown.org/works/56548051',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Hinata and Sasuke bring in some strays from the rain.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Candy-Heart',
        title: 'Candy Heart',
        link: 'https://archiveofourown.org/works/56618527',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'The power a small gesture has on a broken heart.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'I-Miss-You',
        title: 'I Miss You',
        link: 'https://archiveofourown.org/works/56640325',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Love across distance and time zones.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Afraid-of-the-Dark',
        title: 'Afraid of the Dark',
        link: 'https://archiveofourown.org/works/56663356',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'A dark night with candle light.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Its-Cold-Out',
        title: 'It’s Cold Out',
        link: 'https://archiveofourown.org/works/56741908',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke helps Hinata warm up from the cold.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Mine-and-Yours',
        title: 'Mine and Your’s',
        link: 'https://archiveofourown.org/works/56832754',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'What does Sasuke think of his brother and Hinata’s cousin together?',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Bun-in-the-Oven',
        title: 'Bun in the Oven',
        link: 'https://archiveofourown.org/works/56880793',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke likes to think he is the observant one until it maters.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Bloody-Justice',
        title: 'Bloody Justice',
        link: 'https://archiveofourown.org/works/60208951',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'A bloody night and an offered hand.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Halloween'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Cup-of-Sugar',
        title: 'Cup of Sugar',
        link: 'https://archiveofourown.org/works/60175861',
        pairing: 'Fugaku & Hinata',
        pairingId: 'other',
        description: 'Neighbor’s Fugaku and Hinata become friends.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Cold-Nights',
        title: 'Cold Nights',
        link: 'https://archiveofourown.org/works/60149194',
        pairing: 'Itachi x Hinata',
        pairingId: 'itahina',
        description: 'Waking up to a comforting ghost.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Halloween'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Trick-or-Treat',
        title: 'Trick or Treat',
        link: 'https://archiveofourown.org/works/60091693',
        pairing: 'Shikamaru x Hinata',
        pairingId: 'shikahina',
        description: 'Shikamaru and Hinata go trick or treating with Mirai.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Halloween'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'A-Short-Lived-Ghost',
        title: 'A Short Lived Ghost',
        link: 'https://archiveofourown.org/works/60063448',
        pairing: 'Kisame x Hinata',
        pairingId: 'kisahina',
        description: 'Kisame wasn’t going to wear that sheet for long.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Halloween'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    {
        id: 'Bottle-of-Love',
        title: 'Bottle of Love',
        link: 'https://archiveofourown.org/works/60038986',
        pairing: 'Sasuke x Hinata',
        pairingId: 'sasuhina',
        description: 'There were whispers that Hinata made a love potion. Sometimes reality is worse than the rumors.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Halloween'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Christmas 2023 and 2024
    // A Better Year
    {
        id: 'A-Better-Year',
        title: 'A Better Year',
        link: 'https://archiveofourown.org/works/61644226',
        pairing: 'Ino x Hinata',
        pairingId: 'inohina',
        description: 'Hinata has her first fun Christmas with Ino and her family.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Special Delivery
    {
        id: 'Special-Delivery',
        title: 'Special Delivery',
        link: 'https://archiveofourown.org/works/61573381',
        pairing: 'Lee x Hinata',
        pairingId: 'leehina',
        description: 'Lee refuses to someone have a sad face for Christmas.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Merry Freaking Christmas
    {
        id: 'Merry-Freaking-Christmas',
        title: 'Merry Freaking Christmas',
        link: 'https://archiveofourown.org/works/52348627',
        pairing: 'Hidan x Hinata',
        pairingId: 'hidahina',
        description: 'Hinata and Hanabi hire a date to bring to Christmas dinner they know will upset their father.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 2,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Fun and Games
    {
        id: 'Fun-and-Games',
        title: 'Fun and Games',
        link: 'https://archiveofourown.org/works/61512733',
        pairing: 'Deidara x Hinata',
        pairingId: 'deihina',
        description: 'A winter festival and an attempt at shooting ones shot.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // A Cold Castle
    {
        id: 'A-Cold-Castle',
        title: 'A Cold Castle',
        link: 'https://archiveofourown.org/works/61487116',
        pairing: 'Itachi and Hinata',
        pairingId: 'itahina',
        description: 'Itachi spent many years in the castle alone, chasing people away with the ghosts of his past. After all, why would anyone stay?',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Supernatural'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Alone Together for Christmas
    {
        id: 'Alone-Together-for-Christmas',
        title: 'Alone Together for Christmas',
        link: 'https://archiveofourown.org/works/61461007',
        pairing: 'Kisame and Hinata',
        pairingId: 'kisahina',
        description: 'Neighbors both alone for Christmas, choosing to spend the holiday together.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // His Type
    {
        id: 'His-Type',
        title: 'His Type',
        link: 'https://archiveofourown.org/works/61433245',
        pairing: 'Kankuro and Hinata',
        pairingId: 'kankhina',
        description: 'Kankuro didn’t think the weird girl from the groom’s side of his sister’s wedding was his type.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Last Year’s Mistletoe
    {
        id: 'Last-Years-Mistletoe',
        title: 'Last Year’s Mistletoe',
        link: 'https://archiveofourown.org/works/61406470',
        pairing: 'Sasuke and Hinata',
        pairingId: 'sasuhina',
        description: 'A desperate kiss from last year comes back to haunt Sasuke.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Thank You For Hitting Me With Your Car
    {
        id: 'Thank-You-For-Hitting-Me-With-Your-Car',
        title: 'Thank You For Hitting Me With Your Car',
        link: 'https://archiveofourown.org/works/52420816',
        pairing: 'Itachi and Hinata',
        pairingId: 'itahina',
        description: 'Hinata takes Itachi to the hospital after he runs out into a crosswalk.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 2,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Modern AU'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Santa's Nap
    {
        id: 'Santas-Nap',
        title: 'Santa’s Nap',
        link: 'https://archiveofourown.org/works/61349944',
        pairing: 'Choji and Hinata',
        pairingId: 'chohina',
        description: 'Choji looks awfully cute as Santa.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // A Last Minute Toy
    {
        id: 'A-Last-Minute-Toy',
        title: 'A Last Minute Toy',
        link: 'https://archiveofourown.org/works/61321993',
        pairing: 'Shikamaru and Hinata',
        pairingId: 'shikahina',
        description: 'Hinata and Shikamaru go last minute shopping for a very special gift.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Second-Hand Presents
    {
        id: 'Second-Hand-Presents',
        title: 'Second-Hand Presents',
        link: 'https://archiveofourown.org/works/52468480',
        pairing: 'Sasuke and Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke has been receiving gifts not meant for him for years. It was time to change that.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Christmas Shopping
    {
        id: 'Christmas-Shopping',
        title: 'Christmas Shopping',
        link: 'https://archiveofourown.org/works/52468381',
        pairing: 'Ino and Hinata',
        pairingId: 'inohina',
        description: 'Christmas slow dancing and suspiciously short sweaters.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // In The Snow
    {
        id: 'In-The-Snow',
        title: 'In The Snow',
        link: 'https://archiveofourown.org/works/52468294',
        pairing: 'Gaara and Hinata',
        pairingId: 'Gaahina',
        description: 'Gaara experiences his first Winter Festival.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // By the Fire
    {
        id: 'By-the-Fire',
        title: 'By the Fire',
        link: 'https://archiveofourown.org/works/52398103',
        pairing: 'Shikamaru and Hinata',
        pairingId: 'shikahina',
        description: 'Skiing mishaps lead to sitting by the fire.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // In The Backroom
    {
        id: 'In-The-Backroom',
        title: 'In The Backroom',
        link: 'https://archiveofourown.org/works/52321774',
        pairing: 'Sasori and Hinata',
        pairingId: 'sasohina',
        description: 'A jaded pawn shop owner and the bright smile next door.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // She's Asleep
    {
        id: 'Shes-Asleep',
        title: 'She’s Asleep',
        link: 'https://archiveofourown.org/works/52321774',
        pairing: 'Shikamaru and Hinata',
        pairingId: 'shikahina',
        description: 'A quiet holiday night.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Big Brother’s Cute Friend
    {
        id: 'Big-Brothers-Cute-Friend',
        title: 'Big Brother’s Cute Friend',
        link: 'https://archiveofourown.org/works/52276087',
        pairing: 'Kisame and Hinata',
        pairingId: 'kisahina',
        description: 'Hinata falls for her big brother Itachi’s friend.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },
    // Sitting in the Snow
    {
        id: 'Sitting-in-the-Snow',
        title: 'Sitting in the Snow',
        link: 'https://archiveofourown.org/works/52254508',
        pairing: 'Sasuke and Hinata',
        pairingId: 'sasuhina',
        description: 'Sasuke had to get outside. He didn’t want to watch Hinata smile at everyone else but him anymore.',
        completedStatus: 'Complete',
        length: 'oneShot',
        chapters: 1,
        tags: [
            {
                icon: 'fa fa-tree',
                tagName: 'Christmas'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Romance'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Fluff'
            },
            {
                icon: 'fa fa-tag',
                tagName: 'Happy Ending'
            },
        ]
    },


    //
    // {
    //     id: '',
    //     title: '',
    //     link: 'https://archiveofourown.org/works/',
    //     pairing: 'x Hinata',
    //     pairingId: 'sasuhina',
    //     description: '',
    //     completedStatus: 'Complete',
    //     chapters: 0,
    //     tags: [
    //         {
    //             icon: 'fa fa-tag',
    //             tagName: 'Romance'
    //         },
    //         {
    //             icon: 'fa fa-tag',
    //             tagName: 'Happy Ending'
    //         },
    //     ]
    // },
];
